import { WebSocketLink } from '@apollo/client/link/ws';
import { getAppSyncAuthorizationInfo } from 'util/auth';
import { CustomSubscriptionClient } from './customSubscriptionClient';
import { graphqlOperationNormalizationAdapter } from './graphqlOperationNormalizationAdapter';

export const createWebsocketLink = (wsUrl, host) =>
  new WebSocketLink(
    new CustomSubscriptionClient(
      wsUrl,
      {
        reconnect: true,
        timeout: 5 * 60 * 1000
      },
      getAppSyncAuthorizationInfo(host)
    ).use([
      graphqlOperationNormalizationAdapter(getAppSyncAuthorizationInfo(host))
    ])
  );
